import { LongRunningAction } from '../../../../server-communication/running-actions/types/longRunningAction.decorator';
import { LongRunningContextCategoryTyp } from '../../../../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { IBrickInstanceTargetingAction } from '../../../../utility/IBrickInstanceTargetingAction';

export class ChangeBrickTitle {
   public static readonly type = '[CommonBrickSettings] Change brick title';

   constructor(public brickInstanceId, public newTitle: string) {}
}

export class ChangeBrickScaling {
   public static readonly type = '[CommonBrickSettings] Change brick scaling';

   constructor(public brickInstanceId, public newScaling: number) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.SETTINGS)
export class SaveAllChangedBrickSettings {
   public static readonly type = '[Brick Wall Actions] Save all changed brick settings';

   constructor(public brickIds: string[]) {}
}
